import { createAsyncThunk } from '@reduxjs/toolkit';
import * as API from '../api/index.js';
import { notification } from 'antd';
import { toggleModal } from '../reducers/generalReducer.js';
import { getUserId } from '../selectors/user.js';
import { selectPerPage } from '../selectors/general.js';

export const fetchUsers = createAsyncThunk(
    'users/fetchUsers',
    async ({ page, query }, { getState, rejectWithValue }) => {
        try {
            const perPage = selectPerPage(getState());
            const { maxPageNumber, users } = await API.user.getWithPagination(page, perPage, query);
            const existingList = getState().users.list || [];
            return {
                maxPageNumber,
                list: page ? [...existingList, ...users] : users,
            };
        } catch (err) {
            notification.error({ message: 'Error', description: err.message || 'Server error' });
            return rejectWithValue(err.message);
        }
    },
);

export const addUser = createAsyncThunk('users/addUser', async ({ profile }, { dispatch, rejectWithValue }) => {
    try {
        const { userId } = await API.user.addUser(profile);
        const newUser = { ...profile, id: userId, Teams: [] };
        dispatch(toggleModal({ modal: 'user', isOpen: false }));
        notification.success({ message: 'Success', description: 'New user created' });
        return newUser;
    } catch (err) {
        let errMsg = err.message;
        if (err.message === 'Validation error') {
            errMsg = 'Phone number you entered already assigned to existing user. Provide different number';
        }
        notification.error({ message: err.type || 'Error', description: errMsg || '' });
        return rejectWithValue(`${err.name}: ${err.message}`);
    }
});

export const updateUser = createAsyncThunk(
    'users/updateUser',
    async ({ id, profile }, { dispatch, rejectWithValue }) => {
        try {
            await API.user.updateUser(id, profile);
            dispatch(toggleModal({ modal: 'userEdit', isOpen: false }));
            notification.success({ message: 'Success', description: 'User was updated' });
            return { id, ...profile };
        } catch (err) {
            notification.error({ message: err.type || 'Error', description: err.message || '' });
            return rejectWithValue(`${err.name}: ${err.message}`);
        }
    },
);

export const deleteUser = createAsyncThunk('users/deleteUser', async ({ id }, { rejectWithValue }) => {
    try {
        await API.user.deleteUser(id);
        notification.success({ message: 'Success', description: 'User was deleted' });
        return { id };
    } catch (err) {
        notification.error({ message: err.type || 'Error', description: err.message || '' });
        return rejectWithValue(`${err.name}: ${err.message}`);
    }
});

export const getUserProfile = createAsyncThunk('users/getUserProfile', async (_, { getState, rejectWithValue }) => {
    try {
        const id = getUserId(getState());
        const user = await API.user.getById(id);
        return user;
    } catch (err) {
        notification.error({ message: 'Error', description: err.message || 'Server error' });
        return rejectWithValue(err.message);
    }
});

export const updateUserProfile = createAsyncThunk(
    'users/updateUserProfile',
    async ({ profile }, { dispatch, rejectWithValue }) => {
        try {
            const updatedProfile = await API.user.updateProfile(profile);
            dispatch(getUserProfile());
            notification.info({ message: 'Success', description: 'Profile updated!' });
            return updatedProfile;
        } catch (err) {
            notification.error({ message: err.type || 'Error', description: err.message || '' });
            return rejectWithValue(err.message);
        }
    },
);
